import React from 'react';

import { OnboardingState } from '@repo/domain/user';
import shuffle from 'lodash/shuffle';

import { SimpleSurvey } from '../../SimpleSurvey';

import { surveyOptions } from './config';
import { SurveryAnswerProps } from './types';

interface WhatDescribesYouProps {
  onAnswer: (answer: SurveryAnswerProps) => void;
  isDisabled?: boolean;
}

export const WhatDescribesYou: React.FC<WhatDescribesYouProps> = ({
  onAnswer,
  isDisabled = false,
}) => {
  const options = shuffle(surveyOptions);

  const handleSelect = (option: string): void => {
    onAnswer({
      answerText: option,
      onboardingState: OnboardingState.WhatDescribesYou,
    });
  };
  return (
    <SimpleSurvey.Root>
      <SimpleSurvey.Header step={1} title="Which best describes you?" />
      <SimpleSurvey.List>
        {options.map((option) => (
          <SimpleSurvey.Option
            key={option.id}
            icon={option.icon}
            isDisabled={isDisabled}
            label={option.label}
            onClick={() => handleSelect(option.id)}
          />
        ))}
      </SimpleSurvey.List>
    </SimpleSurvey.Root>
  );
};
